import CollectionApi from 'client/api/v2/CollectionApi';

export class IdsourceApiClass extends CollectionApi {
  constructor() {
    super('/api/idsources', {
      skip: 0,
      limit: 50,
      sort: '-lastUpdateTime', // Prepend with a '-' to reverse default sort direction
    });
  }

  fetchAllAgents(domain) {
    const filter = `dn:eq:${domain}`;
    const url = `${this.baseUrl}?filter=${encodeURIComponent(filter)}`;
    return this.getAllItems(url);
  }

  fetchTotalCount(domain) {
    const filter = `dn:eq:${domain}`;
    const url = `${this.baseUrl}?filter=${encodeURIComponent(filter)}`;
    return this.getAllItemsCount(url);
  }
}

export default new IdsourceApiClass();
